import {observable, action} from 'mobx';
import {request} from '@qnpm/vc_fetch';
import Toast from 'components/Toast';
import {formatData} from '../tools';

class Store {
    @observable bannerImg = {};
    @observable taoCanTab = [];
    @observable taoCanList = {};
    @observable showTaoCanList = [];
    @observable hotelTab = [];
    @observable hotelList = {};
    @observable showHotelList = [];
    @observable sights = [];
    @observable introductions = [];
    @observable topVideo = {};
    @observable video = {};

    // 国家馆数据获取
    @action.bound init() {
        request('//touch.dujia.qunar.com/oss/cg/detail?pos=s_abzbgjg&modules=ybtgw,jkcfbq,jkcfcp,pzjdbq,pzjdjd,xhfj,yyty,mhzc')
            .then(res => {
                let {ybtgw = [], jkcfbq = [], jkcfcp = [], pzjdbq = [], pzjdjd = [], xhfj = [], yyty = [], mhzc = []} = res.data;
                if (res.status === 0) {
                    this.bannerImg = formatData(ybtgw)[0];
                    if(this.bannerImg.img.url) {
                        window.QNRSK && window.QNRSK.manual('abu_banner', {etype: 3});
                    }
                    this.taoCanTab = jkcfbq.map(item => ({...item.data, id: item.id}));
                    this.taoCanList = jkcfcp;
                    this.showTaoCanList = formatData(jkcfcp[this.taoCanTab[0].id]);
                    this.hotelTab = pzjdbq.map(item => ({...item.data, id: item.id}));
                    this.hotelList = pzjdjd;
                    this.showHotelList = formatData(pzjdjd[this.hotelTab[0].id]);
                    if (this.showHotelList.length) {
                        window.QNRSK && window.QNRSK.manual('abu_hotel', {etype: 3});
                    }

                    const sightsArr = formatData(xhfj);
                    const sightTemp = [];
                    for(let i = 0; i < Math.ceil(sightsArr.length / 4); i++) {
                        sightTemp[i] = sightsArr.slice(4 * i, 4 * (i + 1));
                    }
                    this.sights = sightTemp;
                    if (this.sights.length) {
                        window.QNRSK && window.QNRSK.manual('abu_tkt', {etype: 3});
                    }

                    const introdArr = formatData(yyty);
                    const introdTemp = [];
                    for (let i = 0; i < Math.ceil(introdArr.length / 3); i++) {
                        introdTemp[i] = introdArr.slice(3 * i, 3 * (i + 1));
                    }
                    this.introductions = introdTemp;
                    if (this.introductions.length) {
                        window.QNRSK && window.QNRSK.manual('abu_gl', {etype: 3});
                    }
                    this.topVideo = formatData(mhzc)[0];
                } else {
                    Toast.show(res.message || '出错了');
                }
            });
    }

    // 切换产品tab
    @action.bound changeTab(id, type) {
        switch(type) {
            case 'taocan':
                this.showTaoCanList = formatData(this.taoCanList[id].slice());
                break;
            case 'hotel':
                this.showHotelList = formatData(this.hotelList[id].slice());
                break;
            default:
                break;
        }
    }

    // 切换播放视频
    @action.bound toggleVideo(data) {
        this.video = data || {};
    }
}

export default new Store();